"use client";

// ── Содержимое вкладки (№2 и №17 каталога движения) ──────────────────────────
// Оборачивает содержимое активной вкладки и даёт ему две вещи:
//   • имя участка для нативного перехода (view-transition-name) — по нему
//     браузер понимает, ЧТО именно анимировать между кадрами (№17);
//   • въезд со стороны перехода там, где нативного API нет (№2).
//
// Направление приходит снаружи: только вызывающий знает порядок вкладок.

import type { ReactNode } from "react";
import type { CSSProperties } from "react";
import type { TabDirection } from "@/lib/view-transition";

export function TabPanel({
  activeKey,
  dir = "fwd",
  name = "tab-content",
  children,
  className,
}: {
  /** Ключ активной вкладки: смена ключа перезапускает въезд. */
  activeKey: string;
  dir?: TabDirection;
  /** Имя участка перехода. Должно быть УНИКАЛЬНЫМ в документе: если на экране
   *  живут вложенные вкладки (вкладка отдела, а внутри неё вкладки HR), общее
   *  имя ломает нативный переход — браузер не понимает, какой из двух блоков
   *  сопоставлять. Вложенным передаём своё имя, для него есть те же правила
   *  в app/globals.css. */
  name?: "tab-content" | "tab-content-inner";
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      // key перемонтирует блок при смене вкладки — иначе CSS-анимация не
      // перезапустится: для браузера это тот же самый элемент.
      key={activeKey}
      className={`tab-panel ${className ?? ""}`}
      data-dir={dir}
      style={{ viewTransitionName: name } as CSSProperties}
    >
      {children}
    </div>
  );
}
